<template>
  <div id="m_header">
    <div class="box_36 flex-col">
      <div class="nav-bar_3 justify-between">
        <img class="image_5" v-if="hasBack" referrerpolicy="no-referrer" @click="gotoBack" src="../../assets/left.png" />
        <span v-else class="icon"></span>
        <span class="text_1" @click="$router.push('/')">{{ getTitle }}</span>
        <img class="label_1" v-if="hasSearch" referrerpolicy="no-referrer" src="../../assets/search.png"
          @click="toSearch" />
        <img class="label_1" v-else-if="hasShare" @click="show = true;" referrerpolicy="no-referrer"
          src="../../assets/share.png" />
        <span v-else class="icon icon2"></span>
      </div>
    </div>
    <div class="image_7 flex-col" :class="{ 'mTop': hasBanner }" v-if="hasBanner">
      <img class="image_8" referrerpolicy="no-referrer" src="../../assets/banner.png" />
    </div>
    <div class="block_2 flex-col" :class="{ 'mTop': !hasBanner }" v-if="hasMenubar">
      <div class="list_11 flex-row" :class="noShowScroll && isAndroid  ? 'scroll-style' : ''" @scroll="handleScroll">
        <div class="image-text_6 flex-col justify-between" v-for="(item, index) in list" :key="index"
          @click="toservice(item)">
          <img class="image_3" referrerpolicy="no-referrer" :src="require('../../assets/' + item.img)" />
          <span class="text-group_1">{{ item.name }}</span>
        </div>
      </div>
    </div>
    <div class="page" :class="{ 'mTop': !hasBanner && !hasMenubar }">
      <router-view></router-view>
    </div>
    <van-popup v-model="show" round position="bottom" :style="{ height: '30%' }" class="share-list">
      <div class="box_2 flex-col">
        <div class="section_2 flex-row">
          <i></i>
          <span>分享</span>
          <i></i>
        </div>
        <div class="image-wrapper_6 flex-row justify-around">
          <div>
            <img class="image_3" referrerpolicy="no-referrer" src="../../assets/wx.png" />
            <p class="text_2">微信好友</p>
          </div>
          <div>
            <img class="image_4" referrerpolicy="no-referrer" src="../../assets/pyq.png" />
            <p class="text_3">朋友圈</p>
          </div>
          <div @click="copyEvent">
            <img class="image_5" referrerpolicy="no-referrer" src="../../assets/link.png" />
            <p class="text_4">复制链接</p>
          </div>
        </div>
      </div>
    </van-popup>
  </div>
</template>

<script>
const u = navigator.userAgent;
const isAndroid = u.indexOf('Android') > -1 || u.indexOf('Adr') > -1; //android终端
export default {
  data() {
    return {
      show: false,
      list: [
        { name: '藏品故事', img: 'collectionStory.png', url: '/m_collectionStory' },
        { name: '大图精览', img: 'datu.png', url: '/m_imgTextList' },
        { name: '共品音画', img: 'coProduct.png', url: '/m_videoListNew' },
        { name: '在线订购', img: 'choose.png', url: '/m_onlineChose' },
        { name: '诗词曲', img: 'poetry.png', url: 'http://hlm.artronartdata.com/shici/#/index' },
        { name: '红楼人物', img: 'character.png', url: 'http://hlm.artronartdata.com/gxtp/' },
      ],
      noShowScroll: true,
      isAndroid: isAndroid
    }
  },
  created() {
  },
  computed: {
    hasBack() {
      return this.$route.meta && this.$route.meta.back;
    },
    hasSearch() {
      return this.$route.meta && this.$route.meta.search;
    },
    hasShare() {
      return this.$route.meta && this.$route.meta.share;
    },
    hasBanner() {
      return this.$route.meta && this.$route.meta.banner;
    },
    getTitle() {
      return this.$route.meta && (this.$route.meta.title || '《红楼梦》绘本艺术图集专题');
    },
    hasMenubar() {
      return this.$route.meta && this.$route.meta.menubar;
    },
  },
  methods: {
    // 返回
    gotoBack() {
      this.$router.go(-1);
    },

    toSearch() {
      this.$router.push({
        path: '/m_search'
      })
    },
    toservice(item) {
      if(item.url.includes('http')) {
        window.location.href = item.url;
        return
      }
      this.$router.push({
        path: item.url
      })
    },

    // 安卓手机改为初次进入页面不显示滚动条，滑动才显示
    handleScroll() {
      if(isAndroid) {
        this.noShowScroll = false;
      }
    },

   



    // 复制链接
    copyEvent() {
      var textArea = document.createElement('textarea')
      document.body.appendChild(textArea)
      textArea.readOnly = 'readonly'
      textArea.style.opacity = '0'
      textArea.value = window.location.href //你的要被复制的链接
      textArea.select()
      if (textArea.setSelectionRange)
        textArea.setSelectionRange(0, textArea.value.length)
      else
        textArea.select()
      document.execCommand("copy")
      this.show = false;
      this.$toast.success('链接已成功复制到剪贴板');
      document.body.removeChild(textArea)
    },
  }
}
</script>

<style lang="scss" scoped>
#m_header {
  .box_36 {
    width: 100%;
    max-width: 500px;
    position: fixed;
    top: 0;
    z-index: 2;

    .nav-bar_3 {
      width: 100%;
      background-color: rgba(249, 249, 249, 1);
      height: 0.4rem;
      line-height: 0.4rem;
      align-items: center;
      padding: 0 0.14rem;

      .image_5 {
        width: 0.095rem;
        height: 0.16rem;
        cursor: pointer;
      }

      .icon {
        display: inline-block;
        width: 0.095rem;
        &.icon2 {
          width: 0.16rem;
        }
      }

      .text_1 {
        color: rgb(51, 51, 51);
        font-size: 0.17rem;
        line-height: 0.16rem;
      }

      .label_1 {
        width: 0.16rem;
        height: 0.16rem;
        cursor: pointer;
      }
    }
  }

  .image_7 {
    .image_8 {
      width: 100%;
      height: 1.61rem;
    }
  }

  .block_2 {
    background-color: rgba(255, 252, 245, 1);
    width: 100%;
    position: relative;
    margin-bottom: 0.08rem;

    .list_11 {
      // justify-content: space-around;
      margin: 0.2rem 0.2rem 0 0.2rem;
      padding-bottom: 0.2rem;
      overflow: auto;

      .image-text_6 {
        width: 0.62rem;
        height: 0.855rem;
        cursor: pointer;
        margin-right: 0.18rem;
        
        &:last-of-type {
          margin-right: 0;
        }

        .image_3 {
          width: 0.6rem;
          height: 0.6rem;
        }

        .text-group_1 {
          width: 0.59rem;
          height: 0.14rem;
          overflow-wrap: break-word;
          color: rgba(0, 0, 0, 1);
          font-size: 0.15rem;

          text-align: center;
          white-space: nowrap;
          line-height: 0.15rem;
          margin: 0.095rem 0 0 0.015rem;
        }
      }
    }
    .scroll-style {
      &::-webkit-scrollbar {
        height: 0;
      }
    }

  }

  .page {
    height: calc(100vh - 1.75rem);
  }

  .mTop {
    margin-top: 0.4rem;
  }

  .share-list {
    .section_2 {
      margin: 0.4rem 0;
      padding: 0 0.1rem;

      i {
        display: inline-block;
        width: 38%;
        background: #E6E6E6;
        height: 1px;
        margin-top: 0.11rem;
      }

      span {
        font-size: 0.18rem;
        padding: 0 0.2rem;
      }
    }

    .image-wrapper_6 {
      div {
        img {
          width: 0.5rem;
        }
      }
    }
  }
}
</style>